/**
 * Company / org logo URL: normalize API nulls, legacy `…/null` S3 paths, and fall back to EM logo.
 */

export function isBlankLogoValue(v) {
  if (v == null) return true;
  const s = String(v).trim();
  if (s === '') return true;
  const low = s.toLowerCase();
  if (low === 'null' || low === 'undefined') return true;
  return false;
}

const emLogo = () => process.env.REACT_APP_EM_LOGO || '';

/** Always returns a string (never null): blank or bad URL → REACT_APP_EM_LOGO. */
export function sanitizeCompanyLogoUrl(url) {
  const fallback = emLogo();
  if (isBlankLogoValue(url)) return fallback;
  const s = String(url).trim();
  try {
    const u = new URL(s);
    const segments = u.pathname.split('/').filter(Boolean);
    const last = segments[segments.length - 1];
    if (last && (last.toLowerCase() === 'null' || last.toLowerCase() === 'undefined')) {
      return fallback;
    }
  } catch {
    if (/\/null$/i.test(s) || /\/undefined$/i.test(s)) return fallback;
  }
  return s;
}

export function sanitizeUserCompanyLogo(user) {
  if (!user || typeof user !== 'object') return user;
  const clean = sanitizeCompanyLogoUrl(user.companyLogoUrl);
  if (clean === user.companyLogoUrl) return user;
  return { ...user, companyLogoUrl: clean };
}
